import {isNumber} from 'underscore';
import {HPosition, VPosition} from '../types';
import {HorizontalPositionProperties, PositionProperties, VerticalPositionProperties} from './types';

const verticalOffset = 64;
const horizontalOffset = 16;

export function getPositionProperties(vPos: VPosition | number, hPos: HPosition | number): PositionProperties {
	return {...getVerticalPosition(vPos), ...getHorizontalPosition(hPos)};
}

export function getVerticalPosition(vPos: VPosition | number): VerticalPositionProperties {
	switch (vPos) {
		case 'bottom':
			return {top: 'unset', bottom: verticalOffset};
		case 'top':
			return {top: verticalOffset, bottom: 'unset'};
		case 'center':
			return {top: 'unset', bottom: 'unset'};
	}

	if (isNumber(vPos)) {
		return {top: vPos, bottom: 'unset'};
	}
	return {top: 'unset', bottom: 'unset'};
}

export function getHorizontalPosition(hPos: HPosition | number): HorizontalPositionProperties {
	switch (hPos) {
		case 'left':
			return {left: horizontalOffset, right: 'unset'};
		case 'right':
			return {left: 'unset', right: horizontalOffset};
		case 'center':
			return {left: 'unset', right: 'unset'};
	}

	if (isNumber(hPos)) {
		return {left: hPos, right: 'unset'};
	}
	return {left: 'unset', right: 'unset'};
}
